
namespace TabAurous.Reports {

    @Serenity.Decorators.registerClass()
    export class ShortListCategoryWiseGrid extends Serenity.EntityGrid<ShortListCategoryWiseRow, any> {
        protected getColumnsKey() { return 'Reports.ShortListCategoryWise'; }
        protected getIdProperty() { return ShortListCategoryWiseRow.idProperty; }
        protected getInsertPermission() { return ShortListCategoryWiseRow.insertPermission; }
        protected getLocalTextPrefix() { return ShortListCategoryWiseRow.localTextPrefix; }
        protected getService() { return ShortListCategoryWiseService.baseUrl; }
        public vouchernos: string[];
        public vouchertypeid: number;
        constructor(container: JQuery) {
            super(container);

            this.setTitle("");
        }
        protected getButtons() {
            var buttons = super.getButtons();
            var self = this;
            buttons = buttons.filter(x => x.cssClass == "");
            buttons.push({
                title: 'Filters',
                cssClass: 'send-button',
                icon: 'fa-filter',
                onClick: () => {
                    var dialog = new Common.FiltersDialog;
                    dialog.filterformfor = "Transaction";
                    dialog.dialogOpen();
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {
                            (this.view.params as ReportFiltersRequest).VoucherTypeId = dialog.vouchertypeid;
                            this.vouchertypeid = dialog.vouchertypeid;
                            this.vouchernos = dialog.vouchernos;
                            var vouchernos = this.vouchernos;
                            //this.onViewSubmit();
                            this.view.refresh();
                            ShortListCategoryWiseService.List({ VoucherTypeId: dialog.vouchertypeid, VoucherNos: vouchernos }, response => { this.view.setItems(response.Entities) }, { async: false });
                        }
                    });
                }
            });
            buttons.push({
                title: 'Export',
                cssClass: 'send-button',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }
                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: ShortListCategoryWiseService.baseUrl + '/OrderDetailSelectedExportExcel',
                        request: {
                            CategoryWiseItems: items,
                        },

                        target: '_blank'
                    });
                }
            });
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Short List"
            }));
            buttons.push(Serenity.ColumnPickerDialog.createToolButton(this as any));
            buttons.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Transactions.ShortListCategoryWiseRegister',
                getParams: () => ({
                    VoucherTypeId: self.vouchertypeid,
                    VoucherNos: self.vouchernos
                }),

            }));
            return buttons;
        }
        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params;

            //var vouchertypeid = this.vouchertypeid;
            //var voucherno = request.EqualityFilter.VoucherNo;
            //var partyids = request.EqualityFilter.PartyId;
            //(this.view.params as ReportFiltersRequest).VoucherTypeId = vouchertypeid;
            //(this.view.params as ReportFiltersRequest).VoucherNo = voucherno;
            //(this.view.params as ReportFiltersRequest).PartyIds = partyids;
            //this.refresh();
            return true;
        }


    }
}